// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OEBjr","name":"styles_name__15GRV","phone":"styles_phone__1hRQ_"};